// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"UnAssignAgentModal_buttonContainer__2tmp5"};